module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    " + _vm._s(_vm.getValue) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f0de6d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/BooleanColumnComponent.vue
// module id = 1317
// module chunks = 2